
export { DataLinkModule } from './data-link.module';